<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
            <h2 class="white--text">
                {{ $t('forget-password.texts.resale') }}
            </h2>
            <v-card class="elevation-6">
                <v-toolbar flat>
                    <v-toolbar-title>{{
                        $t('forget-password.texts.title')
                    }}</v-toolbar-title>
                </v-toolbar>

                <v-form @submit.prevent="forget" ref="form" lazy-validation>
                    <v-card-text>
                        <v-text-field
                            :label="$t('forget-password.labels.email')"
                            v-model="form.email"
                            prepend-icon="mdi-domain"
                            type="text"
                            :error-messages="emailErrors"
                            @input="$v.form.email.$touch()"
                            @blur="$v.form.email.$touch()"
                            autofocus
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            class="light-blue accent-2"
                            dark
                            block
                            :loading="loading"
                            type="submit"
                            >{{ $t('forget-password.buttons.submit') }}</v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card>
            <div class="mt-4 text-center">
                <v-btn small text dark :to="{ name: 'login' }">{{
                    $t('forget-password.actions.login')
                }}</v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],

    data() {
        return {
            form: {
                email: '',
            },
            loading: false,
        }
    },

    methods: {
        async forget() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('forget-password.bus.forget-password-error'),
                )
                return
            }

            this.loading = true

            let res = null

            try {
                res = await this.$http
                    .post('/auth/password/forget', this.form)
                    .catch(() => {
                        this.$bus.$emit(
                            'notify',
                            'error',
                            this.$t('forget-password.bus.requisition-error'),
                        )
                    })
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit('notify', 'success', res.data.message)

            this.$router.push({ name: 'login' })
        },
    },

    validations: {
        form: {
            email: { required, email },
        },
    },

    computed: {
        emailErrors() {
            const errors = []
            if (!this.$v.form.email.$dirty) return errors
            !this.$v.form.email.required &&
                errors.push(
                    this.$t('forget-password.messages.email-error-required'),
                )
            !this.$v.form.email.email &&
                errors.push(
                    this.$t('forget-password.messages.email-error-email'),
                )
            return errors
        },
    },
}
</script>
